import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"

import { Link, graphql, useStaticQuery } from "gatsby"


import GallerySmall from "../components/gallerySmall"

const Komercja = () => {
  const contentfullData = useStaticQuery(graphql`
  query {
    allContentfulAlbum(filter: { typ: { eq: "komercja" } }) {
      edges {
        node {
          nazwa
          typ
          zdjecie_albumu{
           fluid(maxHeight: 1000 maxWidth: 1000){
            ...GatsbyContentfulFluid
          }
          }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <Head title="komercja"></Head>
      <GallerySmall
        contentfullData={contentfullData}
        title="komercja"
      ></GallerySmall>
    </Layout>
  )
}

export default Komercja
